import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { FilterInputErrorProps as Props } from './types';

export const FilterInputError = memo(({ className, message }: Props) => {
  return (
    <Box
      className={classnames('FilterInputError', className)}
      display="flex"
      alignItems="flex-start"
      sx={SX.root}
    >
      <Typography variant="body5" color="error">
        {message}
      </Typography>
    </Box>
  );
});

FilterInputError.displayName = 'FilterInputError';
